/**
 * Shared scoring formula used by all game modes.
 *
 * timeBonusPct = maxTimeBonusPct × accuracy × (timeLeft / totalTime)
 *
 * The accuracy term means a player must perform well to unlock the full
 * time bonus — low accuracy proportionally reduces the time bonus ceiling.
 * The result is always clamped to [0, maxTimeBonusPct].
 *
 * @param {number} accuracy       - Fraction correct (0..1)
 * @param {number} timeLeft       - Seconds remaining on the timer
 * @param {number} totalTime      - Total timer duration in seconds
 * @param {number} maxTimeBonusPct - Max fractional bonus allowed, e.g. 0.30 = 30%
 * @returns {number} bonus fraction in [0, maxTimeBonusPct]
 */
export function calcTimeBonusPct(accuracy, timeLeft, totalTime, maxTimeBonusPct) {
  const clampedAccuracy = Math.max(0, Math.min(1, accuracy));
  const timeFactor = Math.max(0, Math.min(1, timeLeft / totalTime));
  return maxTimeBonusPct * clampedAccuracy * timeFactor;
}
